import { Circle } from "lucide-react";

export default function ProblemSection() {
  const bullets = [
    "A burst of late-night excitement where you buy a beautiful, dated book.",
    "Three days of perfect, color-coded planning.",
    "Life happens, you miss a Tuesday, and the perfect record is broken.",
    "Now, those blank pages stare back at you like a report card of your personal failure.",
    "The guilt makes you freeze, you close the book, and another $25 goes into the graveyard.",
  ];

  return (
    <section
      data-testid="problem-section"
      className="py-20 md:py-28"
      style={{ backgroundColor: "#1e1e1f" }}
    >
      <div className="max-w-3xl mx-auto px-5 md:px-12">
        {/* Sub-heading */}
        <h2
          className="text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight mb-8 text-center"
          style={{ fontFamily: "'Fraunces', serif", color: "#e0e0e0" }}
          data-testid="problem-heading"
        >
          You do not lack willpower. You are just using tools built for
          neurotypical brains.
        </h2>

        {/* Intro text */}
        <p
          className="text-base leading-relaxed mb-8"
          style={{ fontFamily: "'Inter', sans-serif", color: "#b0b0b5" }}
        >
          If you have ADHD, you probably have a drawer, a shelf, or a folder
          that has become a graveyard of half-used planners. They usually look
          like this:
        </p>

        {/* Bullet list */}
        <ul className="space-y-4 mb-10">
          {bullets.map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <Circle
                className="w-2 h-2 mt-2 flex-shrink-0"
                style={{ color: "#7C3AED", fill: "#7C3AED" }}
              />
              <span
                className="text-base leading-relaxed"
                style={{ fontFamily: "'Inter', sans-serif", color: "#e0e0e0" }}
              >
                {item}
              </span>
            </li>
          ))}
        </ul>

        {/* Quote block */}
        <blockquote
          className="relative my-10 py-8 px-8 rounded-xl"
          style={{
            backgroundColor: "rgba(124, 58, 237, 0.06)",
            borderLeft: "3px solid #7C3AED",
          }}
          data-testid="problem-quote"
        >
          <p
            className="text-lg italic leading-relaxed"
            style={{ fontFamily: "'Fraunces', serif", color: "#e0e0e0" }}
          >
            &ldquo;The first half is an empty dated planner... so I can not even
            reuse the empty planner pages.&rdquo;
          </p>
        </blockquote>

        {/* Closing lines */}
        <div className="space-y-4 mt-8">
          <p
            className="text-base leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif", color: "#e0e0e0" }}
          >
            The problem is not your brain. The problem is the tool. Traditional
            systems are built on neurotypical consistency. They punish you for
            being human.
          </p>
        </div>
      </div>
    </section>
  );
}
